export default __webpack_public_path__ + "static/media/10_1.51654a4c.png";